import * as Types from "src/state/_types"
import * as GQL from "src/state/gql/_types"

export const OperationsAdminVenueBookingViewSchema: Types.ViewSchemaType<GQL.BookingFragment> = {
    enums: [],
    fields: [
        {
            label: "Date",
            field: "date",
            type: "date"
        },
        {
            label: "Event Start Time",
            field: "event_start_time",
            type: "time"
        },
        {
            label: "Event End Time",
            field: "event_end_time",
            type: "time"
        },
        {
            label: "Set Start Time",
            field: "set_start_time",
            type: "time"
        },
        {
            label: "Set End Time",
            field: "set_end_time",
            type: "time"
        },
        {
            label: "Notes",
            field: "notes",
            type: "text"
        },
        {
            label: "Rate",
            field: "rate",
            type: "currency"
        },
        {
            label: "Rate Type",
            field: "rate_type",
            type: "text"
        },
        {
            label: "Rate Margin",
            field: "rate_margin",
            type: "number"
        },
        {
            label: "Invoice Target",
            field: "invoice_target",
            type: "text"
        },
        {
            label: "Poc",
            field: "poc",
            type: "text"
        },
        {
            label: "Created At",
            field: "created_at",
            type: "datetime"
        },
        {
            label: "Updated At",
            field: "updated_at",
            type: "datetime"
        },
        {
            label: "Recurring",
            field: "recurring",
            type: "boolean"
        }
    ],
    relations: {
        series: {
            relation: "series",
            label: "Recurring Series",
            fields: [
                {
                    label: "Recurring Schedule",
                    field: "rrule",
                    type: "rrule"
                }
            ]
        },
        tenant: {
            relation: "tenant",
            label: "Tenant",
            fields: [
                {
                    label: "Type",
                    field: "type",
                    type: "text"
                },
                {
                    label: "Tenant Number",
                    field: "tenant_number",
                    type: "number"
                },
                {
                    label: "Name",
                    field: "name",
                    type: "text"
                }
            ]
        },
        venue: {
            relation: "venue",
            label: "Venue",
            fields: [
                {
                    label: "Type",
                    field: "type",
                    type: "text"
                },
                {
                    label: "Tenant Number",
                    field: "tenant_number",
                    type: "number"
                },
                {
                    label: "Name",
                    field: "name",
                    type: "text"
                },
                {
                    label: "Address Line1",
                    field: "address_line1",
                    type: "text"
                },
                {
                    label: "Address Line2",
                    field: "address_line2",
                    type: "text"
                },
                {
                    label: "City",
                    field: "city",
                    type: "text"
                },
                {
                    label: "State",
                    field: "state",
                    type: "text"
                },
                {
                    label: "Country",
                    field: "country",
                    type: "text"
                },
                {
                    label: "Postal Code",
                    field: "postal_code",
                    type: "text"
                },
                {
                    label: "Phone",
                    field: "phone",
                    type: "text"
                }
            ]
        },
        area: {
            relation: "area",
            label: "Area",
            fields: [
                {
                    label: "Type",
                    field: "type",
                    type: "text"
                },
                {
                    label: "Area Number",
                    field: "area_number",
                    type: "number"
                },
                {
                    label: "Name",
                    field: "name",
                    type: "text"
                },
                {
                    label: "Description",
                    field: "description",
                    type: "text"
                }
            ]
        },
        talent: {
            relation: "talent",
            label: "Talent",
            fields: [
                {
                    label: "Tenant Id",
                    field: "tenant_id",
                    type: "text"
                },
                {
                    label: "Role",
                    field: "role",
                    type: "text"
                },
                {
                    label: "Status",
                    field: "status",
                    type: "text"
                },
                {
                    label: "Type",
                    field: "type",
                    type: "text"
                },
                {
                    label: "Email",
                    field: "email",
                    type: "text"
                },
                {
                    label: "Alias",
                    field: "alias",
                    type: "text"
                },
                {
                    label: "User Number",
                    field: "user_number",
                    type: "number"
                },
                {
                    label: "First Name",
                    field: "first_name",
                    type: "text"
                },
                {
                    label: "Last Name",
                    field: "last_name",
                    type: "text"
                },
                {
                    label: "Address Line1",
                    field: "address_line1",
                    type: "text"
                },
                {
                    label: "Address Line2",
                    field: "address_line2",
                    type: "text"
                },
                {
                    label: "City",
                    field: "city",
                    type: "text"
                },
                {
                    label: "State",
                    field: "state",
                    type: "text"
                },
                {
                    label: "Country",
                    field: "country",
                    type: "text"
                },
                {
                    label: "Postal Code",
                    field: "postal_code",
                    type: "text"
                },
                {
                    label: "Phone",
                    field: "phone",
                    type: "text"
                },
                {
                    label: "Genres Played",
                    field: "genres",
                    type: "multi-select" 
                },
            ]
        }
    }
}